import React from "react";
import "./Payments.css";
import {
  APP_SECTION,
  ENTITY_TYPE,
  PARTY,
} from "../../../scripts/constants";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {isEqual, mygaSession} from "../../../scripts/myga-session";
import {saveApplication} from "../../../scripts/sync-manager";
import {Button, Col, Container, Form, Modal, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Resources from "../../../Resources/Resources";
import CurrencyInput from "../../../components/CurrencyInput";
import {charLimits, NassauLog, regex, toCurrencyNoDecimal} from "../../../scripts/myga-utils";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import PopoverTooltip from "../../../components/PopoverTooltip";
import {isPaymentScenarioValid} from "../../../scripts/validation";
import {dtoForProduct, makePayment, productForDTO} from "../../../scripts/product-manager";
import {
  MM_CALCULATOR,
  MM_PAYMENT,
  MM_PAYMENT_EFT, MM_PAYMENT_TYPE,
  MM_PRODUCT,
  MM_PRODUCT_DTO,
  MM_PRODUCT_VISUALS
} from "../../../scripts/myga-model";
import GENERATOR from "../../../selenium-front-end/generator/Generator";

const toElementId = (string) => string.replace(/ /g,'_').toLowerCase();

const BTN_ADD_CHK_ID = 'addPaymentChk';
const BTN_ADD_EFT_ID = 'addPaymentEft';
const BTN_SAVE_PMT_ID = 'savePayment';
const BTN_CANCEL_PMT_ID = 'cancelPayment';
const BTN_DELETE_PMT_ID = 'deletePayment';
const BTN_EDIT_PMT_ID = 'editPayment';

class Payments extends React.Component {
  
  constructor(props) {
    super(props);
    
    // make a deep-copy.
    const DTOs = JSON.parse(JSON.stringify(mygaSession.getCurrentAppProductDTOs()));
    
    this.state = {
      cart: DTOs.map(dto=>productForDTO(dto)),
      payors: [...mygaSession.getCurrentAppParties()],
      showPaymentModal: false,
      paymentModalMessage: '',
      prevPaymentAmount: 0,
      isEdit: false,
      editProductId: '',
      errorMessage: '',
      newPaymentSelection: MM_PAYMENT_TYPE.bankEFT
    }

    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      this.generateActionList = async () => {
        let actionList = [];
      
        // Get the current product DTOs
        const initProductDTOs = [...mygaSession.getCurrentAppProductDTOs()];
        const nextProductDTOs = this.state.cart.map(p=>dtoForProduct(p));
        const initPayments = initProductDTOs.map(dto=>dto[MM_PRODUCT_DTO.payments]);
        const nextPayments = nextProductDTOs.map(dto=>dto[MM_PRODUCT_DTO.payments]);
        // NassauLog(`initPayments: ${JSON.stringify(initPayments,null,2)}`);
        // NassauLog(`nextPayments: ${JSON.stringify(nextPayments,null,2)}`);
        
        // if there were no changes there is nothing todo.
        if (isEqual(initPayments,nextPayments)) return;
        NassauLog(`payments changed`);
      
        // Remove any current payments
        initProductDTOs.forEach((dto)=>{
          // remove the payments in reverse order
          const dtoPayments = dto[MM_PRODUCT_DTO.payments];
          for (let index=dtoPayments.length-1; index>=0; index--) {
            actionList.push({
              type: 'click',
              id: `${BTN_DELETE_PMT_ID}_${dto[MM_PRODUCT_DTO.productID]}_${index}`,
              stagedId: `${BTN_DELETE_PMT_ID}_${dto[MM_PRODUCT_DTO.productID]}_${index}`
            });
          }
        });
      
        // 2022.06.01.ADivelbiss - Add all payments in our cart
        nextProductDTOs.forEach((dto)=>{
          // iterate each payment in this DTO
          dto[MM_PRODUCT_DTO.payments].forEach((pmt)=>{
            // NassauLog(`processing test payment: ${pmt[MM_PAYMENT.paymentID]}`);
            // press the add button
            const addPaymentID = `${pmt[MM_PAYMENT.paymentType]===MM_PAYMENT_TYPE.check?BTN_ADD_CHK_ID:BTN_ADD_EFT_ID}`;
            actionList.push({
              type: 'click',
              id: `${addPaymentID}_${dto[MM_PRODUCT_DTO.productID]}`,
              stagedId: `${addPaymentID}_${dto[MM_PRODUCT_DTO.productID]}_${pmt[MM_PAYMENT.paymentID]}`
            });
            // set the amount
            actionList.push({
              type: 'keys',
              value: pmt[MM_PAYMENT.amount],
              id: `${MM_PAYMENT.amount}`,
              stagedId: `${MM_PAYMENT.amount}_${pmt[MM_PAYMENT.paymentID]}`
            });
            // handle extra EFT fields
            if (pmt[MM_PAYMENT.paymentType]===MM_PAYMENT_TYPE.bankEFT) {
              actionList.push({
                type: 'keys',
                value: pmt[MM_PAYMENT_EFT.bankName],
                id: `${MM_PAYMENT_EFT.bankName}`,
                stagedId: `${MM_PAYMENT_EFT.bankName}_${pmt[MM_PAYMENT_EFT.paymentID]}`
              });
              actionList.push({
                type: 'keys',
                value: pmt[MM_PAYMENT_EFT.bankRoutingNumber],
                id: `${MM_PAYMENT_EFT.bankRoutingNumber}`,
                stagedId: `${MM_PAYMENT_EFT.bankRoutingNumber}_${pmt[MM_PAYMENT_EFT.paymentID]}`
              });
              actionList.push({
                type: 'keys',
                value: pmt[MM_PAYMENT_EFT.bankAccountNumber],
                id: `${MM_PAYMENT_EFT.bankAccountNumber}`,
                stagedId: `${MM_PAYMENT_EFT.bankAccountNumber}_${pmt[MM_PAYMENT_EFT.paymentID]}`
              });
              actionList.push({
                type: 'keys',
                value: pmt[MM_PAYMENT_EFT.bankAccountNumberConfirm],
                id: `${MM_PAYMENT_EFT.bankAccountNumberConfirm}`,
                stagedId: `${MM_PAYMENT_EFT.bankAccountNumberConfirm}_${pmt[MM_PAYMENT_EFT.paymentID]}`
              });
              actionList.push({
                type: 'click',
                id: `checking_${MM_PAYMENT_EFT.bankAccountType}`,
                stagedId: `checking_${MM_PAYMENT_EFT.bankAccountType}_${pmt[MM_PAYMENT_EFT.paymentID]}`
              });
              // find the index of the current payor
              const payorIndex = this.state.payors.findIndex(p=>p[PARTY.uid]===pmt[MM_PAYMENT_EFT.payorUid]);
              actionList.push({
                type: 'click',
                id: `${MM_PAYMENT_EFT.payorUid}_${payorIndex}`,
                stagedId: `${MM_PAYMENT_EFT.payorUid}_${payorIndex}_${pmt[MM_PAYMENT.paymentID]}`
              });
              // get the payor
              const payor = this.state.payors[payorIndex];
              // check to see if this payor is a trust
              if (payor[PARTY.entityType]===ENTITY_TYPE.trust) {
                NassauLog(`payor: ${JSON.stringify(payor,null,2)}`);
                // payor[PARTY.ssnOrTaxId]
                actionList.push({
                  type: 'keys',
                  value: payor[PARTY.ssnOrTaxId],
                  id: `${PARTY.ssnOrTaxId}`,
                  stagedId: `${PARTY.ssnOrTaxId}_${pmt[MM_PAYMENT.paymentID]}`
                });
              }
            }
            // save
            actionList.push({
              type: 'click',
              id: `${BTN_SAVE_PMT_ID}`,
              stagedId: `${BTN_SAVE_PMT_ID}_${pmt[MM_PAYMENT.paymentID]}`
            });
            // delay
            actionList.push({
              type: 'sleep',
              value: 500,
              stagedId: `sleep_${pmt[MM_PAYMENT.paymentID]}`
            });
          });
        });
      
        await GENERATOR.stageManualActionList(actionList)
      }
    }
  }

  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Finances_ErrorMissingInformation
      });
      return false;
    }
    
    if (!isPaymentScenarioValid({
      [APP_SECTION.products]: this.state.cart.map(p=>dtoForProduct(p))
    })) {
      this.setState({errorMessage: MYGAStrings.Payments_NotEnoughMoney});
      return false;
    }
    
    return true;
  };
  
  saveApplication = async () => {
    
    // Save the cart data
    mygaSession.setCurrentAppProductDTOs(this.state.cart.map(p=>dtoForProduct(p)));
  
    // Save to the backend
    await saveApplication(APP_SECTION.products)

    // check to see if the payors changed
    if (!isEqual(this.state.payors,mygaSession.getCurrentAppParties())) {
      mygaSession.setCurrentAppParties([...this.state.payors]);
      await saveApplication(APP_SECTION.parties);
    }
    
  };
  
  onBackPressed = async () => {
    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      await this.generateActionList()
    }
    await this.saveApplication()
  }
  
  onNextPressed = async () => {
    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      await this.generateActionList()
    }
    await this.saveApplication()
  }
  
  headerStyles = {
    backgroundColor: 'rgba(242, 193, 102, 0.25)',
    width: '100%',
    fontSize: '1.5em',
    marginTop: '20px'
  };
  
  tableStyle = {
    //backgroundColor: 'rgba(242, 193, 102, 0.25)',
    width: '100%'
  };
  
  nameColumnStyle = {
    width: '50%'
  };
  
  allocationColumnStyle = {
    width: '25%'
  };
  
  relationshipColumnStyle = {
    width: '25%'
  };
  
  leftColWidth = 'col-5 col-sm-4 p-0';
  rightColWidth = 'col-3 col-sm-4 p-0';
  
  newPayment = (productId, paymentType) => this.setState({
    showPaymentModal: true,
    errorMessage: '',
    payment: makePayment(paymentType),
    payor: mygaSession.getCurrentAppOwner(),
    editProductId: productId
  });
  
  editPayment = (payment, productId) => this.setState({
    showPaymentModal: true,
    errorMessage: '',
    isEdit: true,
    editProductId: productId,
    prevPaymentAmount: payment[MM_PAYMENT.amount],
    payment: {...payment},
    payor: {...this.state.payors.find(p=>p[PARTY.uid]===payment[MM_PAYMENT_EFT.payorUid])}
  });
  
  hidePayment = () => this.setState({
    payment: null,
    payor: null,
    showPaymentModal: false,
    paymentModalMessage: '',
    prevPaymentAmount: 0,
    editProductId: ''
  });
  
  
  /**
   * @returns {number}
   */
  currentBalance = () => {
    const product = this.state.cart.find(p=>p[MM_PRODUCT.productID]===this.state.editProductId);
    if (!product) return 0;
    const premium = product[MM_PRODUCT.dto][MM_PRODUCT_DTO.premium];
    const payment = product[MM_PRODUCT.dto][MM_PRODUCT_DTO.payments].reduce((total,payment)=>total+payment[MM_PAYMENT.amount],0);
    return premium - payment;
  };
  
  paymentHandleChange = (field) => (e) => {
    let payment = this.state.payment;
    let value = e.target.value;
    if (field === MM_PAYMENT.amount) {
      value = Math.min(value, this.currentBalance() + this.state.prevPaymentAmount);
    }
    payment[field] = value;
    let nextState = {payment: payment};
    if (field === MM_PAYMENT_EFT.payorUid) {
      nextState.payor = this.state.payors.find(p=>p[PARTY.uid]===value);
    }
    this.setState(nextState);
  };
  
  paymentAmountHandleChange = (value) => {
    this.paymentHandleChange(MM_PAYMENT.amount)({target: {value}});
  };
  
  removePayment(payment, productID) {
    
    const productIndex = this.state.cart.findIndex(p=>p[MM_PRODUCT.productID]===productID);
    if (productIndex<0) return;
    
    const paymentIndex = this.state.cart[productIndex][MM_PRODUCT.dto][MM_PRODUCT_DTO.payments].findIndex(p=>(p[MM_PAYMENT.paymentID]===payment[MM_PAYMENT.paymentID]));
    if (paymentIndex<0) return;
    
    const nextCart = [...this.state.cart];
    nextCart[productIndex][MM_PRODUCT.dto][MM_PRODUCT_DTO.payments].splice(paymentIndex, 1);
  
    this.setState({cart: nextCart});
  }
  
  savePayment() {

    if (!this.modalForm.checkValidity()) {
      let errorMessage = MYGAStrings.PaymentInfo_ErrorMissingInformation;
      this.modalForm.classList.add('was-validated');
      this.setState({
        paymentModalMessage: errorMessage
      });
      return;
    }
    
    // payment modal validation
    if (this.state.payment.paymentType === MM_PAYMENT_TYPE.bankEFT) {
      // check for account number
      if (this.state.payment[MM_PAYMENT_TYPE.bankAccountNumber] !== this.state.payment[MM_PAYMENT_TYPE.bankAccountNumberConfirm]) {
        this.setState({
          paymentModalMessage: 'Bank account numbers must match.'
        });
        return;
      }
    }
    
    //Need to set the amount value based on type due to the lambdas requirements.
    // fixed warning for directly manipulating the state
    const payment = {...this.state.payment};
    payment[payment.paymentType + "_Amount"] = payment.amount;
  
    const nextCart = [...this.state.cart];
    const productIndex = nextCart.findIndex(p=>p[MM_PRODUCT.productID]===this.state.editProductId);
    const paymentIndex = nextCart[productIndex][MM_PRODUCT.dto][MM_PRODUCT_DTO.payments].findIndex(p=>(p[MM_PAYMENT.paymentID]===payment[MM_PAYMENT.paymentID]));
    if (paymentIndex<0) {
      nextCart[productIndex][MM_PRODUCT.dto][MM_PRODUCT_DTO.payments].push(payment);
    } else {
      nextCart[productIndex][MM_PRODUCT.dto][MM_PRODUCT_DTO.payments][paymentIndex] = payment;
    }
    // NassauLog(`nextCart: ${JSON.stringify(nextCart,null,2)}`);
    
    // need to see if we should save the payor
    const nextPayors = [...this.state.payors];
    if (this.state.payor) {
      const payorIndex = nextPayors.findIndex(p=>p[PARTY.uid]===this.state.payor[PARTY.uid]);
      nextPayors[payorIndex] = this.state.payor;
    }
    
    this.setState({
      cart: nextCart,
      payment: null,
      payor: null,
      payors: nextPayors,
      showPaymentModal: false,
      prevPaymentAmount: 0,
      paymentModalMessage: '',
      isEdit: false,
      editProductId: '',
      errorMessage: ''
    });
  }
  
  updateSelectedNewPaymentType = (newType) => {
    this.setState({newPaymentSelection: newType});
  };
  
  renderPayors = () => {
    const isPayorTrust = this.state.payor[PARTY.entityType]===ENTITY_TYPE.trust;
    return (
        <>
          <Row className="pb-1">
            <Col sm={6}>
              Payor
            </Col>
            <Col sm={6}>
              <select className={"form-control"}
                      id={`${MM_PAYMENT_EFT.payorUid}`}
                      disabled={this.state.payors.length===0}
                      value={this.state.payment[MM_PAYMENT_TYPE.payorUid]}
                      onChange={this.paymentHandleChange(MM_PAYMENT_TYPE.payorUid)}>
                <option disabled value="">Select a Payor</option>
                {
                  this.state.payors.map((p,index)=>{
                    if (p[PARTY.entityType]===ENTITY_TYPE.trust) {
                      return (
                          <option id={`${MM_PAYMENT_EFT.payorUid}_${index}`} value={p[PARTY.uid]} key={index}>{`${p[PARTY.trustName]}`}</option>
                      )
                    }
                    return (
                        <option id={`${MM_PAYMENT_EFT.payorUid}_${index}`} value={p[PARTY.uid]} key={index}>{`${p[PARTY.firstName]} ${p[PARTY.lastName]}`}</option>
                    )
                  })
                }
              </select>
            </Col>
          </Row>
          {
            isPayorTrust && (
                <Row>
                  <Col sm={6} className={'pl-5'}>
                    SSN/Tax ID&nbsp;
                    <PopoverTooltip className={'d-inline-block'} title={''} content={MYGAStrings.PaymentView_TaxIdInfo}/>
                  </Col>
                  <Col sm={6}>
                    <Form.Control
                        className="page-input"
                        required
                        type="text"
                        id={PARTY.ssnOrTaxId}
                        name={PARTY.ssnOrTaxId}
                        value={this.state.payor[PARTY.ssnOrTaxId]}
                        onChange={(e)=>{
                          let payor = {...this.state.payor};
                          payor[PARTY.ssnOrTaxId] = e.target.value;
                          this.setState({payor: payor});
                        }}
                        maxLength={charLimits.ssn}
                        pattern={regex.ssn}
                        placeholder={'Tax ID Number'}/>
                  </Col>
                </Row>
              )
          }
        </>
    )
  }
  
  renderPaymentModal = () => {
    return this.state.payment != null ? (
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showPaymentModal}
            onHide={this.hidePayment}
        >
          
          <Modal.Header closeButton>
            {
                this.state.payment.paymentType === MM_PAYMENT_TYPE.bankEFT &&
                <Modal.Title>Bank Draft Information</Modal.Title>
            }
            {
                this.state.payment.paymentType === MM_PAYMENT_TYPE.check &&
                <Modal.Title>Check Amount</Modal.Title>
            }
            {/* 2021.04.02.ADivelbiss - Commenting out these payment buttons per meeting today. No need to have these options on the Payment page since the PathB skips payment.*/}
            {/*{*/}
            {/*  this.state.payment.paymentType === MM_PAYMENT_TYPE.exchange1035 &&*/}
            {/*  <Modal.Title>1035 Exchange</Modal.Title>*/}
            {/*}*/}
            {/*{*/}
            {/*  this.state.payment.paymentType === MM_PAYMENT_TYPE.rollover &&*/}
            {/*  <Modal.Title>Rollover</Modal.Title>*/}
            {/*}*/}
          
          </Modal.Header>
          
          <Form className={'needs-validation'} ref={(form) => {this.modalForm = form;}}>
            <Modal.Body>
              <Row className="pb-1">
                <div className={'col-12'}><b>Remaining Amount Due:</b>
                  {toCurrencyNoDecimal(this.currentBalance() + this.state.prevPaymentAmount - this.state.payment[MM_PAYMENT.amount])}
                </div>
                <div className="col-sm-6">Amount</div>
                <div className="col-sm-6">
                  <CurrencyInput
                      className={'form-control'}
                      decimalsEnabled={true}
                      style={{maxWidth: '100%'}}
                      id={`${MM_PAYMENT.amount}`}
                      name={MM_PAYMENT.amount}
                      max={this.currentBalance() + this.state.prevPaymentAmount}
                      value={this.state.payment[MM_PAYMENT.amount]}
                      handleChange={this.paymentAmountHandleChange}
                      form="payment"
                  >
                  </CurrencyInput>
                </div>
              </Row>
  
              {
                this.state.payment.paymentType === MM_PAYMENT_TYPE.bankEFT && (
                    <>
                        {/* Institution */}
                        <Row className="pb-1">
                          <div className="col-sm-6">Institution</div>
                          <div className="col-sm-6">
                            <Form.Control type="text"
                              required
                              className="form-input"
                              id={`${MM_PAYMENT_EFT.bankName}`}
                              name={MM_PAYMENT_EFT.bankName}
                              value={this.state.payment[MM_PAYMENT_EFT.bankName]}
                              onChange={this.paymentHandleChange(MM_PAYMENT_EFT.bankName)}
                              placeholder="Bank Name"/>
                          </div>
                        </Row>
  
                        {/* Routing Number */}
                        <Row className="pb-1">
                          <div className="col-sm-6">Routing Number</div>
                          <div className="col-sm-6">
                            <Form.Control type="text" required className="form-input"
                                          id={`${MM_PAYMENT_EFT.bankRoutingNumber}`}
                                          name={MM_PAYMENT_EFT.bankRoutingNumber}
                                          value={this.state.payment[MM_PAYMENT_EFT.bankRoutingNumber]}
                                          onChange={this.paymentHandleChange(MM_PAYMENT_EFT.bankRoutingNumber)}
                                          pattern={regex.bankRoutingNumber}
                                          placeholder="Routing Number"/></div>
                        </Row>
  
                        {/* Account Number*/}
                        <Row className="pb-1">
                          <div className="col-sm-6">Account Number</div>
                          <div className="col-sm-6">
                            <Form.Control type="text" required className="form-input"
                                          id={`${MM_PAYMENT_EFT.bankAccountNumber}`}
                                          name={MM_PAYMENT_EFT.bankAccountNumber}
                                          value={this.state.payment[MM_PAYMENT_EFT.bankAccountNumber]}
                                          onChange={this.paymentHandleChange(MM_PAYMENT_EFT.bankAccountNumber)}
                                          pattern={regex.bankAccountNumber}
                                          placeholder="Account Number"/></div>
                        </Row>
  
                        {/* Confirm Account Number */}
                        <Row className="pb-1">
                          <div className="col-sm-6">Confirm Account Number</div>
                          <div className="col-sm-6">
                            <Form.Control type="text" required className="form-input"
                                          id={`${MM_PAYMENT_EFT.bankAccountNumberConfirm}`}
                                          name={MM_PAYMENT_EFT.bankAccountNumberConfirm}
                                          value={this.state.payment[MM_PAYMENT_EFT.bankAccountNumberConfirm]}
                                          onChange={this.paymentHandleChange(MM_PAYMENT_EFT.bankAccountNumberConfirm)}
                                          pattern={regex.bankAccountNumber}
                                          placeholder="Confirm Account Number"/></div>
                        </Row>
  
                        {/* Account Type */}
                        <Row className="pb-1">
                          <div className="col-sm-6">
                            Account Type
                          </div>
                          <div className="col-sm-6">
                            <select className={"form-control"}
                                    id={`${MM_PAYMENT_EFT.bankAccountType}`}
                                    value={this.state.payment[MM_PAYMENT_EFT.bankAccountType]}
                                    onChange={this.paymentHandleChange(MM_PAYMENT_EFT.bankAccountType)}>
                              <option disabled value="">Make a Selection</option>
                              <option id={`checking_${MM_PAYMENT_EFT.bankAccountType}`} value="Checking">Checking</option>
                              {/*<option value="Savings">Savings</option>*/}
                            </select>
                          </div>
                        </Row>
  
                        {/* Payor Selection */}
                        {this.renderPayors()}
  
                        {/* Where to find the numbers */}
                        <Row className={'pt-3 pb-1'}>
                          <div className="col-sm-11 where-to-find-numbers-div">
                            <PopoverTooltip
                                placement={'top'}
                                trigger={['click']}
                                content={
                                  <div className={'where-find-numbers-image'}>
                                    <img alt={'where to find numbers on check'} width={'100%'} src={Resources.Images.CheckImage}/>
                                  </div>
                                }>
                              <div className={'where-to-find-numbers-text'}>
                                {'Where do I find these numbers?'}
                              </div>
                            </PopoverTooltip>
                          </div>
                        </Row>
                    </>
                  )
              }
              
              {/* Payment Modal Message */}
              <Row className="text-center pb-2" style={{color: "red"}}>
                <Col>
                  {this.state.paymentModalMessage}
                </Col>
              </Row>
  
            </Modal.Body>
            
           </Form>
          
          
          <Modal.Footer style={{justifyContent: 'space-between', flexWrap: 'nowrap'}}>
            <Button id={`${BTN_CANCEL_PMT_ID}`} variant="secondary" onClick={(e) => this.hidePayment()}>
              Cancel
            </Button>
            <Button id={`${BTN_SAVE_PMT_ID}`} variant="primary" onClick={(e) => this.savePayment()}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
    ) : (<></>)
  }
  
  renderPaymentsForProduct = (product) => {
  
    return (
        <Container fluid className={'p-0'} style={{borderTop: '1px gray solid'}}>
          {
            product[MM_PRODUCT.dto][MM_PRODUCT_DTO.payments].map((payment, index) => {
              let paymentTypeCol;
    
              switch (payment.paymentType) {
                case MM_PAYMENT_TYPE.bankEFT:
                  paymentTypeCol = (
                      <Container fluid className={'p-0'}>
                        <Row>
                          {payment['bank_name']}
                        </Row>
                        <Row>
                          {payment['bank_account_type']}
                        </Row>
                      </Container>
                  );
                  break;
      
                case MM_PAYMENT_TYPE.check:
                  paymentTypeCol = 'Mail Check';
                  break;
      
                case MM_PAYMENT_TYPE.exchange1035:
                  paymentTypeCol = '1035';
                  break;
      
                case MM_PAYMENT_TYPE.rollover:
                  paymentTypeCol = 'Rollover';
                  break;
                default:
                  paymentTypeCol = '';
              }
    
              return (
                  <Row key={index} style={{borderBottom: '1px gray solid'}}>
                    <Col className={this.leftColWidth} style={{display: 'flex', alignItems: 'center'}}>
                      {paymentTypeCol}
                    </Col>
                    <Col className={this.rightColWidth} style={{display: 'flex', alignItems: 'center'}}>
                      {toCurrencyNoDecimal(parseFloat(payment.amount))}
                    </Col>
                    <Col className={'col-2 pl-0 pt-1 pb-1'} style={{display: 'flex'}}>
                      <Button id={`${BTN_EDIT_PMT_ID}_${product[MM_PRODUCT.productID]}_${index}`} className={'btn-edit-remove'}
                              onClick={(event) => {
                                this.editPayment(payment, product[MM_PRODUCT.productID])
                              }}>
                        <FontAwesomeIcon icon={Resources.Icons.Pencil}/>
                      </Button>
                    </Col>
                    <Col className={'col-2 pl-0 pt-1 pb-1'} style={{display: 'flex'}}>
                      <Button id={`${BTN_DELETE_PMT_ID}_${product[MM_PRODUCT.productID]}_${index}`} className={'btn-edit-remove myga-trash'}
                              onClick={(event) => {
                                this.removePayment(payment, product[MM_PRODUCT.productID])
                              }}>
                        <FontAwesomeIcon icon={Resources.Icons.TrashCan}/>
                      </Button>
                    </Col>
                  </Row>
              )
            })
          }
        </Container>
    )
  }
  
  renderAddPaymentForProduct = (product) => {
    const productID = product[MM_PRODUCT.productID];
    const premium = product[MM_PRODUCT.dto][MM_PRODUCT_DTO.premium];
    const payment = product[MM_PRODUCT.dto][MM_PRODUCT_DTO.payments].reduce((total,payment)=>total+payment[MM_PAYMENT.amount],0);
    return (premium > payment) ? (
        <Container fluid className={'mt-3 mb-3 p-0'}>
          <Row>
            <Col className={'col-12 col-sm-4 col-md-6 col-lg-7 p-0'}>
              <b>Add Payment</b>
            </Col>
            
            {/* Non Phone */}
            <Col className={'d-none d-sm-block col-12 col-sm-8 col-md-6 col-lg-5 p-0'}>
              <Container className={'p-0'}>
                <Row>
                  <Col className={'col-6 pl-0'}>
                    <Button className={'nsre-button'} id={`${BTN_ADD_EFT_ID}_${productID}`} variant="primary" onClick={(e) => this.newPayment(productID, MM_PAYMENT_TYPE.bankEFT)}>
                      EFT
                    </Button>
                  </Col>
                  <Col className={'col-6 pl-0'}>
                    <Button className={'nsre-button'} id={`${BTN_ADD_CHK_ID}_${productID}`} variant="primary" onClick={(e) => this.newPayment(productID, MM_PAYMENT_TYPE.check)}>
                      CHECK
                    </Button>
                  </Col>
                </Row>
                <Row className={'mt-3'}>
                  {/* 2021.04.02.ADivelbiss - Commenting out these payment buttons per meeting today. No need to have these options on the Payment page since the PathB skips payment.*/}
                  {/*<Col className={'col-6 pl-0'}>*/}
                  {/*  <Button variant="primary" onClick={(e) => this.newPayment(productID, MM_PAYMENT_TYPE.exchange1025)}>*/}
                  {/*    1035*/}
                  {/*  </Button>*/}
                  {/*</Col>*/}
                  {/*<Col className={'col-6 pl-0'}>*/}
                  {/*  <Button variant="primary" onClick={(e) => this.newPayment(productID, MM_PAYMENT_TYPE.rollover)}>*/}
                  {/*    Rollover*/}
                  {/*  </Button>*/}
                  {/*</Col>*/}
                </Row>
              </Container>
            </Col>
            {/* End Non Phone */}
            
            {/* Phone */}
            <Col className={'d-block d-sm-none col-12'}>
              <Container className={'p-0'}>
                <Row>
                  <Col className={'col'}>
                    <Form.Control as={'select'}
                                  onChange={(e) => this.updateSelectedNewPaymentType(e.target.value)}>
                      <option value={MM_PAYMENT_TYPE.bankEFT}>EFT</option>
                      <option value={MM_PAYMENT_TYPE.check}>Check</option>
                      {/* 2021.04.02.ADivelbiss - Commenting out these payment buttons per meeting today. No need to have these options on the Payment page since the PathB skips payment.*/}
                      {/*<option value={MM_PAYMENT_TYPE.exchange1035}>1035</option>*/}
                      {/*<option value={MM_PAYMENT_TYPE.rollover}>Rollover</option>*/}
                    </Form.Control>
                  </Col>
                  <Col className={'col-1 m-auto'}>
                    <FontAwesomeIcon icon={faPlus}
                                     size={'lg'}
                                     className={'addPaymentIcon'}
                                     onClick={() => this.newPayment(productID, this.state.newPaymentSelection)}/>
                  </Col>
                </Row>
              </Container>
            </Col>
            {/* End Phone */}
          </Row>
        
        </Container>
    ) : (<Container/>)
  };
  
  renderBalanceForProduct = (product) => {
    const premium = product[MM_PRODUCT.dto][MM_PRODUCT_DTO.premium];
    const payment = product[MM_PRODUCT.dto][MM_PRODUCT_DTO.payments].reduce((total,payment)=>total+payment[MM_PAYMENT.amount],0);
    const balance = premium - payment;
    return (
        <Container fluid className={'mb-5 p-0'}>
          <Row>
            <Col className={this.leftColWidth}><b>Amount Due:</b></Col>
            <Col className={this.rightColWidth}>{toCurrencyNoDecimal(balance)}</Col>
          </Row>
        </Container>
    )
  }
  
  renderCartItem = (product) => {
    let visuals = product[MM_PRODUCT.visuals];
    let calc = product[MM_PRODUCT.calculator];
    return (
        <div style={{margin: '1em'}} key={product[MM_PRODUCT.productID]}>
  
          {/* Product description */}
          <Container fluid className={'mb-3 p-0'}>
            <Row>
              <Col className={this.leftColWidth}>
                <b>
                  {visuals[MM_PRODUCT_VISUALS.title]}<sup>{visuals[MM_PRODUCT_VISUALS.tradeMark]}</sup><br/>
                  {visuals[MM_PRODUCT_VISUALS.surrenderPeriod]} Period
                </b>
              </Col>
              <Col className={this.rightColWidth} style={{display: 'flex'}}>
                <b style={{alignSelf: 'flex-end'}}>
                  Premium
                </b>
              </Col>
            </Row>
            <Row>
              <Col className={this.leftColWidth}>
                {parseFloat(calc[MM_CALCULATOR.rate]).toFixed(2) + "%"}
              </Col>
              <Col className={this.rightColWidth}>
                {toCurrencyNoDecimal(calc[MM_CALCULATOR.premium])}
              </Col>
            </Row>
          </Container>
  
          {this.renderPaymentsForProduct(product)}
      
          {this.renderAddPaymentForProduct(product)}
  
          {this.renderBalanceForProduct(product)}
    
        </div>
        
    )
  }
  
  render() {
    
    return (
        
        <AppContentWrapper
            validateOnNext={this.validate}
            onBackPressed={this.onBackPressed}
            onNextPressed={this.onNextPressed}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>
  
  
          <form className={'needs-validation'}
                ref={(form) => {
                  this.pageForm = form;
                }}>
          </form>
          
          {/* render the cart payment status */}
          {this.state.cart.map((item)=>this.renderCartItem(item))}
          
          {/* handle the payment modal dialog */}
          {this.renderPaymentModal()}
          
        
        </AppContentWrapper>
    
    );
    
  }
  
}

export default Payments;